import gql from "graphql-tag";
import { tagFragment, customTagLabelFragment, customTagFragment } from '@/graphql/tag/tagFragments'

export const UPSERTPROFESSION = gql`
    mutation upsertProfession (
        $id: ID
        $name: String
        $shortname: String
        $isForeman: Boolean
    ){
        upsertProfession(
            input: {
                id: $id
                name: $name
                shortname: $shortname
                isForeman: $isForeman
            }
        ){
            ...tagFragment
        }
    }
    ${tagFragment}
`
export const UPSERTSKILL = gql`
    mutation upsertSkill (
        $id: ID
        $name: String
        $shortname: String
    ){
        upsertSkill(
            input: {
                id: $id
                name: $name
                shortname: $shortname
            }
        ){
            ...tagFragment
        }
    }
    ${tagFragment}
`

export const UPSERTCOURSE = gql`
    mutation upsertCourse (
        $id: ID
        $name: String
        $shortname: String
    ){
        upsertCourse(
            input: {
                id: $id
                name: $name
                shortname: $shortname
            }
        ){
            ...tagFragment
        }
    }
    ${tagFragment}
`

export const UPSERTCUSTOMTAG = gql`
    mutation upsertCustomTag (
        $id: ID!
        $name: String
        $shortname: String
        $customtag_label_id: ID!
    ){
        upsertCustomTag(
            input: {
                id: $id
                name: $name
                shortname: $shortname
                label: {
                    connect: $customtag_label_id
                }
            }
        ){
            ...customTagFragment
            label{
                ...customTagLabelFragment
            }
        }
    }
    ${customTagFragment}
    ${customTagLabelFragment}
`

export const UPSERTCUSTOMTAGLABEL = gql`
    mutation upsertCustomTagLabel (
        $id: ID!
        $name: String
        $applyTo: ApplyToModels
    ){
        upsertCustomTagLabel(
            id: $id
            name: $name
            applyTo: $applyTo
        ){
            ...customTagLabelFragment
        }
    }
    ${customTagLabelFragment}
`

export const DELETETAG = gql`
    mutation deleteTag (
        $id: ID!
    ){
        deleteTag(
            id: $id
        ){
            ...tagFragment
        }
    }
    ${tagFragment}
`
export const RESTORETAG = gql`
    mutation restoreTag (
        $id: ID!
    ){
        restoreTag(
            id: $id
        ){
            ...tagFragment
        }
    }
    ${tagFragment}
`

export const RESTORECUSTOMTAGLABEL = gql`
    mutation restoreCustomtaglabel (
        $id: ID!
    ){
        restoreCustomtaglabel(
            id: $id
        ){
            ...customTagLabelFragment
        }
    }
    ${customTagLabelFragment}
`

export const DELETECUSTOMTAGLABEL = gql`
    mutation deleteCustomtaglabel (
        $id: ID!
    ){
        deleteCustomtaglabel(
            id: $id
        ){
            ...customTagLabelFragment
        }
    }
    ${customTagLabelFragment}
`